var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-xs font-bold text-red-800"},[_vm._v(" Please Note: Watermark will NOT be printed on the final product. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }